import { Link } from 'react-router-dom';
import type { CoachLevel } from '@4cm/core/profiles';
import { Card } from '../components/primitives';
import { useCalibration } from '../contexts/CalibrationContext';
import './page-shell.css';

interface LevelOption {
  level: CoachLevel;
  title: string;
  body: string;
}

const OPTIONS: LevelOption[] = [
  {
    level: 'NOVICE',
    title: 'Novice',
    body: 'I am brand new — first season, learning the basics. Show me the simplest path through the app.',
  },
  {
    level: 'GRASSROOTS',
    title: 'Grassroots',
    body: 'I coach a community team. I know the basics; I want help planning, not lectures.',
  },
  {
    level: 'COMPETITIVE',
    title: 'Competitive',
    body: 'My team plays in a competitive league. I need depth on weekly load, opposition, and player development.',
  },
  {
    level: 'ADVANCED',
    title: 'Advanced',
    body: 'I work in an academy or high-performance environment. Surface every metric.',
  },
  {
    level: 'ELITE_CAT1',
    title: 'Elite — Cat 1',
    body: 'I run an elite or Cat 1 academy. Full workbench density, opposition, recruiting, periodisation.',
  },
];

export function CalibrationSettings() {
  const { coachLevel, setCoachLevel } = useCalibration();

  return (
    <main className="main page">
      <header className="page-head">
        <Link to="/settings" className="page-back">← Settings</Link>
        <h1 className="page-title">Calibration</h1>
        <p className="page-sub">How experienced are you? The app adapts.</p>
      </header>
      <ul className="calibration-list">
        {OPTIONS.map((o) => {
          const active = o.level === coachLevel;
          return (
            <li key={o.level}>
              <button
                type="button"
                className="calibration-card"
                data-active={active || undefined}
                onClick={() => setCoachLevel(o.level)}
              >
                <Card variant={active ? 'glass' : 'opaque'}>
                  <div className="calibration-card__title">{o.title}</div>
                  <p className="calibration-card__body">{o.body}</p>
                </Card>
              </button>
            </li>
          );
        })}
      </ul>
    </main>
  );
}
